<div [ngClass]='{
  "float-left": alignLeft,
  "float-right": alignRight,
  "float-center": alignCenter,
  "text-value-container": true,
  "value-container": true
}'>
  <span>  {{value[valueConfig.name]  | datatype:valueConfig.dataType:valueConfig.dataFormat}}</span>
</div>